import ActiveSurfaceView from 'mini-calendar-surface-store/lib/store/schema/ActiveSurfaceView';
import { ACTIVE_CALENDAR_SURFACE_VIEW } from 'mini-calendar-surface-store/lib/utils/constants';
import { getCalendarInfoStore } from 'mini-calendar-events-store/lib/store/store';
import { getItem } from 'mini-localstorage';

/**
 * Method to return the last active calendar view.
 */
export default function getLastActiveCalendarView(): ActiveSurfaceView {
    let activeSurface = hasSelectedPeoplesCalendar()
        ? ActiveSurfaceView.DAY
        : ActiveSurfaceView.AGENDA;
    const activeCalendarViewFromSession = getItem(ACTIVE_CALENDAR_SURFACE_VIEW);
    const activeSurfaceNumber = activeCalendarViewFromSession
        ? parseInt(activeCalendarViewFromSession)
        : -1;
    if (!isNaN(activeSurfaceNumber) && activeSurfaceNumber in ActiveSurfaceView) {
        activeSurface = activeSurfaceNumber;
    }
    return activeSurface;
}

const hasSelectedPeoplesCalendar = () =>
    getCalendarInfoStore()
        .getAllCalendarInfo()
        .filter(calendar => calendar.isSelected && calendar.isGeneralScheduleCalendar).length > 0;
